import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import images from '../../../services/images';
import ContentHeader from '../../parts/ContentHeader';
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import initTreeView from '../../../services/initTreeView';
import appSession from '../../../services/session';
// import DataTable from 'react-data-table-component';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chart } from 'primereact/chart';
import { BsBagCheck, BsCart2, BsCartCheck, BsCartX  } from "react-icons/bs";
import { AiOutlineFileExclamation, AiOutlineFileExcel, AiOutlineFileSync, AiOutlineFileDone   } from "react-icons/ai";
 
export default function ClientDashboard (){
    const [loading, setLoading] = useState(0);
    const [statistic, setStatistic] = useState([]);
    const navigate = useNavigate();

    const [errors, setErrors] = useState([]);

    
    const [widget_data, setWidgetData] = useState({
        "open": 0,
        "confirmed": 0,
        "closed": 0,
        "cancelled": 0
    });
    const [top_items, setTopItems] = useState([]);
    const [low_stock_items, setLowStockItems] = useState([]);
    const [sales_orders, setSalesOrders] = useState([]);
    const [purchases_orders, setPurchasesOrders] = useState([]);

    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

   
    useEffect(() => {
        initTreeView()
        //Mounted
        fetchWidgetData()
    }, []);
   
    useEffect(() => {
        displayTopItems()
        displayLowStockItems()
        displaySalesOrderTable()
        displayPurchasesOrderTable()
    }, [widget_data]);

    useEffect(() => {
        const options = {
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        };

        setChartOptions(options);
    }, []);

    function removeErrors(e){
        let { name } = e.target;
        let newErrors = {...errors}

        delete newErrors[name];

        setErrors(newErrors);
    }

    function fetchWidgetData(){
        setLoading(1)
        let filter = '?store_id='+helpers.getStoreID()+'&'
        filter = filter.slice(0, -1)

        const url = helpers.createUrl(`V1/widgets/client${filter}`)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setWidgetData(res.data)
                setLoading(0)
            })
            .catch((err) => {
                setLoading(0)

                if(err.message === 'Unauthenticated.'){
                    Swal.fire({
                        title: "Invalid Access Token!",
                        text: err.message,
                        icon: "error",
                        confirmButtonText: "OK",
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.isConfirmed) {
                            appSession.deleteSession()
                        }
                    })
                }
                else{
                    Swal.fire({
                        title: "Error!",
                        text: err.message,
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                }
            }); 
    }

    function displayTopItems(){
        setTopItems(
            <DataTable
                value={widget_data.top_items} 
                size="small"
                lazy
                scrollHeight="300px"
                scrollable
                stripedRows
                emptyMessage="No data to display"
            >
                <Column 
                    field="product_name" 
                    header="Name" 
                    body={({product_name, product_variant_name})=> `${product_name} (${product_variant_name})`}
                    headerStyle={{ background: '#f9fafb' }}
                />
                <Column 
                    header="Total Sales" 
                    body={({total_sales})=> helpers.formatCurrencyAmount(total_sales)} 
                    headerStyle={{ background: '#f9fafb' }}
                />
                <Column 
                    header="Sold" 
                    body={({sold_quantity, unit_name})=> <>{sold_quantity} <small>{unit_name}</small></>}
                    headerStyle={{ background: '#f9fafb' }}
                />
                {/* <Column 
                    field="product_type_id" 
                    body={({product_type_id})=> product_type_id === 1 ? 'Goods' : 'Services'} 
                    header="Type" 
                    headerStyle={{ background: '#f9fafb' }}
                /> */}
            </DataTable>
        )
    }

    function displayLowStockItems(){
        setLowStockItems(
            <DataTable
                value={widget_data.low_stock_items} 
                size="small"
                lazy
                scrollHeight="300px"
                scrollable
                stripedRows
                //resizableColumns
                emptyMessage="No data to display"
            >
                <Column 
                    field="product_name" 
                    header="Name" 
                    body={({product_name, product_variant_name})=> `${product_name} (${product_variant_name})`}
                    headerStyle={{ background: '#f9fafb' }}
                />
                <Column field="available_stock" header="Stock" headerStyle={{ background: '#f9fafb' }}/>
                <Column header="Level" body={({available_stock, reorder_point})=> helpers.displayStockLevel(available_stock, reorder_point)} headerStyle={{ background: '#f9fafb' }}/>
            </DataTable>
        )
    }

    function displaySalesOrderTable(){
        setSalesOrders(
            <DataTable
                value={widget_data.sales_orders} 
                size="small"
                lazy
                scrollHeight="300px"
                scrollable
                stripedRows
                //resizableColumns
                emptyMessage="No data to display"
            >
                <Column field="order_no" header="Order #" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="order_date" header="Date" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="customer_name" header="Customer" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="total_items" header="Orders" headerStyle={{ background: '#f9fafb' }}/>
                <Column header="Total Amount" body={({total_amount})=> helpers.formatCurrencyAmount(total_amount)}></Column>
            </DataTable>
        )

    }

    function displayPurchasesOrderTable(){
        setPurchasesOrders(
            <DataTable
                value={widget_data.purchases_orders} 
                size="small"
                lazy
                scrollHeight="300px"
                scrollable
                stripedRows
                //resizableColumns
                emptyMessage="No data to display"
            >
                <Column field="order_no" header="Order #" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="order_date" header="Date" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="vendor_name" header="Vendor" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="total_items" header="Orders" headerStyle={{ background: '#f9fafb' }}/>
                <Column header="Total Amount" body={({total_amount})=> helpers.formatCurrencyAmount(total_amount)}></Column>
            </DataTable>
        )
    }

    return (
        <>
        {/* <Layout page_title={"Hello, " + helpers.getUserName()} menu="home" breadcrumbs={false}> */}
        <Layout page_title="Insights" menu="home" breadcrumbs={false}>
                <div className="content">
                    <div className="container-fluid"  style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>

                        {/* <h5>Insights</h5> */}
                        <div className="row">
                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer text-dark" to="/sales/list?status=1">
                                    <span className="info-box-icon bg-warning"><BsCart2 /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">OPEN</span>
                                        <h5 className="info-box-number mb-0">{widget_data?.order_open ?? 0}</h5>
                                        <small className='text-muted'>Sales Order</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer text-dark" to="/sales/list?status=2">
                                    <span className="info-box-icon bg-primary"><BsCartCheck /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text mb-0">CONFIRMED</span>
                                        <h5 className="info-box-number mb-0">{widget_data?.order_confirmed ?? 0}</h5>
                                        <small className='text-muted'>Sales Order</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer text-dark" to="/sales/list?status=3">
                                    <span className="info-box-icon bg-success"><BsBagCheck /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">CLOSED</span>
                                        <h5 className="info-box-number mb-0">{widget_data?.order_closed ?? 0}</h5>
                                        <small className='text-muted'>Sales Order</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer text-dark" to="/sales/list?status=4">
                                    <span className="info-box-icon bg-danger"><BsCartX /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">CANCELLED</span>
                                        <h5 className="info-box-number">{widget_data?.order_cancelled ?? 0}</h5>
                                        <small className='text-muted'>Sales Order</small>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer text-dark" to="/sales/list?invoice_status=5">
                                    <span className="info-box-icon bg-warning"><AiOutlineFileExclamation /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">UNPAID/SENT</span>
                                        <h5 className="info-box-number mb-0">{widget_data?.invoice_sent ?? 0}</h5>
                                        <small className='text-muted'>Sales Order</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer text-dark" to="/sales/list?invoice_status=6">
                                    <span className="info-box-icon bg-primary"><AiOutlineFileSync /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">PARTIALLY PAID</span>
                                        <h5 className="info-box-number mb-0">{widget_data?.invoice_partially_paid ?? 0}</h5>
                                        <small className='text-muted'>Sales Order</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer text-dark" to="/sales/list?invoice_status=7">
                                    <span className="info-box-icon bg-success"><AiOutlineFileDone /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">PAID</span>
                                        <h5 className="info-box-number mb-0">{widget_data?.invoice_paid ?? 0}</h5>
                                        <small className='text-muted'>Sales Order</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer text-dark" to="/sales/list?invoice_status=8">
                                    <span className="info-box-icon bg-danger"><AiOutlineFileExcel /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">CANCELLED INVOICE</span>
                                        <h5 className="info-box-number mb-0">{widget_data?.invoice_cancelled ?? 0}</h5>
                                        <small className='text-muted'>Sales Order</small>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>{/* /.container-fluid */}
                </div>

        </Layout>
        </>
    )
}